var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9683 18C25.8028 18 31.3433 14.9779 31.3433 11.25C31.3433 7.52208 25.8028 4.5 18.9683 4.5C12.1337 4.5 6.59326 7.52208 6.59326 11.25C6.59326 14.9779 12.1337 18 18.9683 18Z",
    stroke: "#339EEC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59326 11.25V18C6.59326 21.7279 12.1337 24.75 18.9683 24.75C25.8028 24.75 31.3433 21.7279 31.3433 18V11.25",
    stroke: "#339EEC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59326 18V24.75C6.59326 28.4779 12.1337 31.5 18.9683 31.5C25.8028 31.5 31.3433 28.4779 31.3433 24.75V18",
    stroke: "#339EEC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/Database.f2b896f13e40806a093b88417a5086f9.svg";
export { ForwardRef as ReactComponent };